import * as React from 'react'
import { useEffect, useRef, useState } from 'react'

import { ReactComponent as SearchIco } from '../../../../Assets/search.svg'
import OutlineButtonSearchIcon from '../../../atoms/Button/Outline/SearchIconButton'
import { RenderButton } from '../../../atoms/Button/RenderButton'
import TextButton from '../../../atoms/Button/Text/Button'

interface Props {
  content?: any
}

const DesktopMenu = ({ content }: Props) => {
  const [isSearchOpen, setIsSearchOpen] = useState(false)
  const searchRef = useRef(null)
  const [query, setQuery] = useState('')
  const inputRef = useRef(null)

  const toggleSearch = () => {
    setIsSearchOpen((prevState) => !prevState)
  }

  useEffect(() => {
    if (isSearchOpen) {
      if (inputRef.current) {
        inputRef.current.focus()
      }
    }
  })

  const handelClickOutside = (event) => {
    if (searchRef.current && !searchRef.current.contains(event.target)) {
      setIsSearchOpen(false)
    }
  }

  useEffect(() => {
    document.addEventListener('mousedown', handelClickOutside)

    return () => {
      document.removeEventListener('mousedown', handelClickOutside)
    }
  })

  const handleSubmit = (e) => {
    e.preventDefault()
    e.stopPropagation()
    window.location.href = `/search-results?query=${encodeURIComponent(query)}`
    setIsSearchOpen(false)
  }

  return (
    <div data-testid="desktopmenu" className="w-full flex-row md:flex">
      <div className="relative flex flex-1 items-center justify-between pl-6">
        <ul className="headerMenu ml-12">
          {content?.fields?.navigationSection?.fields?.menus.map((item, index) => (
            <li className="text-18 float-left m-0 px-16 font-semibold last:border-l" key={`${item?.sys?.id}-${index}`}>
              <TextButton
                variant="light"
                name={item?.fields?.groupName}
                classes="text-neutral-10 hover:underline"
                link={item?.fields?.externelLink}
              />
            </li>
          ))}
        </ul>
        <div>
          {isSearchOpen && (
            <div ref={searchRef} className="absolute right-0 top-0 w-[95%]">
              <form onSubmit={handleSubmit}>
                <div className="relative flex w-full">
                  <button
                    aria-label="Search submit button"
                    type="submit"
                    disabled={query.length < 3}
                    className="absolute inset-y-0 right-0 flex cursor-pointer items-center p-3 px-16 disabled:cursor-default disabled:opacity-40"
                  >
                    <SearchIco />
                  </button>
                  <input
                    ref={inputRef}
                    aria-label="Search Text Input"
                    type="text"
                    className="pr-50 h-[58px] w-full rounded-lg rounded-e-none border border-neutral-50 bg-neutral-10 ps-5 text-lg text-neutral-90 transition-colors duration-300 focus:border-violet-300 focus:outline-none"
                    placeholder="Search..."
                    onChange={(e) => setQuery(e.target.value)}
                  />
                </div>
              </form>
            </div>
          )}
        </div>
      </div>
      <div className="headerBtns flex items-center">
        {!isSearchOpen && (
          <OutlineButtonSearchIcon variant="light" buttonType="button" classes="mr-12" onClick={toggleSearch} />
        )}
        {isSearchOpen && (
          <OutlineButtonSearchIcon variant="dark" buttonType="button" classes="mr-12" onClick={toggleSearch} />
        )}
        <RenderButton item={content?.fields?.navigationSection?.fields?.register} />
        <RenderButton item={content?.fields?.navigationSection?.fields?.login} />
      </div>
    </div>
  )
}
export default DesktopMenu
